interface SkeletonProps {
  className?: string;
}

export const Skeleton = ({ className = "" }: SkeletonProps) => (
  <div className={`skeleton ${className}`} />
);

export const CardSkeleton = () => (
  <div className="bg-surface rounded-xl border border-hairline p-5 space-y-3">
    <Skeleton className="h-4 w-24" />
    <Skeleton className="h-8 w-40" />
    <Skeleton className="h-4 w-32" />
  </div>
);

export const TransactionSkeleton = () => (
  <div className="flex items-center gap-3 py-3.5">
    <Skeleton className="w-9 h-9 !rounded-full flex-shrink-0" />
    <div className="flex-1 space-y-2">
      <Skeleton className="h-4 w-32" />
      <Skeleton className="h-3 w-20" />
    </div>
    <Skeleton className="h-4 w-16" />
  </div>
);

export const DashboardSkeleton = () => (
  <div className="min-h-screen bg-ground">
    {/* Editorial header placeholder */}
    <div className="pb-6 pt-6 px-5 border-b border-hairline">
      <Skeleton className="h-3.5 w-24 mb-3" />
      <Skeleton className="h-10 w-44 mb-2" />
      <Skeleton className="h-3 w-28" />
    </div>

    {/* Quick action pills */}
    <div className="flex gap-2 px-4 mt-4">
      <Skeleton className="h-10 flex-1 !rounded-xl" />
      <Skeleton className="h-10 flex-1 !rounded-xl" />
    </div>

    {/* Card section — dark card object placeholder */}
    <div className="px-4 mt-5 space-y-2.5">
      <Skeleton className="h-3 w-20" />
      <div className="bg-card-obj rounded-[14px] p-5 space-y-3 aspect-[1.7/1]">
        <div className="skeleton-branded h-4 w-24" />
        <div className="skeleton-branded h-5 w-44" />
        <div className="skeleton-branded h-4 w-32" />
      </div>
    </div>

    {/* Transaction section */}
    <div className="px-4 mt-5">
      <div className="bg-surface rounded-xl border border-hairline p-4">
        <Skeleton className="h-3 w-32 mb-3" />
        {[1, 2, 3].map((i) => (
          <TransactionSkeleton key={i} />
        ))}
      </div>
    </div>
  </div>
);
